module.exports = __webpack_public_path__ + "img/img_actividad.9efcded1.svg";